module.exports = __webpack_public_path__ + "static/media/logo_nus.b09921f0.png";